__turbopack_context__.v({
  "menu": "oSUnxq_menu",
  "menu-item": "oSUnxq_menu-item",
  "menu-item--selected": "oSUnxq_menu-item--selected",
  "menu-item--with-separator-after": "oSUnxq_menu-item--with-separator-after",
  "menu-item--with-separator-before": "oSUnxq_menu-item--with-separator-before",
  "menu-item-icon": "oSUnxq_menu-item-icon",
  "popover": "oSUnxq_popover",
  "slide-in": "oSUnxq_slide-in",
  "slide-out": "oSUnxq_slide-out",
  "trigger": "oSUnxq_trigger",
  "trigger--selected": "oSUnxq_trigger--selected",
  "trigger__more-icon": "oSUnxq_trigger__more-icon",
  "trigger__more-icon-wrapper": "oSUnxq_trigger__more-icon-wrapper",
  "wrapper": "oSUnxq_wrapper",
});
